import React, { useState, useEffect } from 'react'
import { getLocalPath } from '../../spa/utility/config/configuration'
import { sleep } from '../../global/_utils.js'
import { isLocal } from '../../global/environments/index.js'
import { getRelativeBasePath } from '../../global/environments/path.js'
import { getInternalRedirectLoginUrl } from '../../global/environments/config.js'
import {
  fetchJsonRawReponse,
  postJsonDataBlankResponse,
  postJsonRawResponse,
  safeFetch,
} from '../../global/data/service.js'
import { clearAllCache } from '../../global/data/service-cache.js'
import { setItem, getItem } from '../../global/data/synch-storage.js'
import {
  checkIfEmailIsInternal,
  getAuthManagerInstance,
  setEmailSubscriptionCenterProfileCookie,
  setLogin,
} from '../../global/authentication/authentication-manager.js'
import {
  setCorelationIds,
  getCorelationIds,
} from '../SelfService/Data/SelfServiceDataSource.js'
import {
  goToRegistrationPageRedirect,
  goToSecurePageRedirect,
} from '../../global/authentication/url-redirector.js'

import { getCreateUser } from '../Login/Data/response-mock.js'

import PasswordValidator from '../Login/Modules/PasswordValidator/PasswordValidator.jsx'

import {
  getFirms,
  getStorageProfile,
  postCheckSubscription,
  setContactKey,
} from '../EmailSubscriptionCenter/Data/SubscriptionCenterDataSource.js'

import InputGroup from '../EmailSubscriptionCenter/SignIn/InputGroup.jsx'
import FormFieldError from '../EmailSubscriptionCenter/SignIn/FormFieldError.jsx'
import Step1Investor from '../EmailSubscriptionCenter/SignIn/Step1Investor.jsx'
import LoadingIndicator from '../EmailSubscriptionCenter/SignIn/LoadingIndicator.jsx'

import { triggerDigitalDataSimple } from '../FundDetails/Helpers/Analytics.js'

import AdditionalInformation from './AdditionalInformation.jsx'
import DOMPurify from 'dompurify'

import './index.css'
import { getSecureProfile } from '../Login/Data/LoginDatasource.js'
import OneTimePasscode from '../Login/Modules/OneTimePasscode.jsx'
import ChallengeChoice from '../Login/Modules/ChallengeChoice.jsx'
import { Loader } from '../../spa/components/index.js'

export default function Register({ tmx_id, websession_id }) {
  const IS_TESTING = false

  const urlSearchParams = new URLSearchParams(window.location.search)

  const storageProfile = getStorageProfile()

  const [firms, setFirms] = useState([])
  const [selectedMode, setSelectedMode] = useState()
  const [selectedModeType, setSelectedModeType] = useState()
  const [selectedModeError, setSelectedModeError] = useState()
  const [selectedToggleDisclosure, setSelectedToggleDisclosure] =
    useState(false)
  const [selectedAgreementCheckbox, setSelectedAgreementCheckbox] =
    useState(false)
  const [token, setToken] = useState()
  const [lead, setLead] = useState(true)
  const [passwordValid, setPasswordValid] = useState(false)
  const [showPasswordValidator, setShowPasswordValidator] = useState(false)
  const [isProcessingRegister, setIsProcessingRegister] = useState(false)
  const [disclosureData, setDisclosureData] = useState({})
  const [maskedPhoneNbr, setMaskedPhoneNbr] = useState('')
  const [validatedProfile, setValidatedProfile] = useState(null)
  const [loading, setLoading] = useState(false)

  const [formData, setFormData] = useState({
    firstNameLegal: '',
    firstName: '',
    lastName: '',
    emailId: '',
    emailIdConfirm: '',
    emailIdAlt: '',
    token: '',
    firmName: '',
    firmId: '',
    phoneNumber: '',
    zipCode: '',
    password: '',
    passwordConfirm: '',
    firmStNm: '',
    firmState: '',
    firmCity: '',
  })

  const [formValidation, setFormValidation] = useState({
    firstNameLegal: {
      error: false,
      errorMessage: 'Please enter your given first name',
    },
    firstName: {
      error: false,
      errorMessage: 'Please enter your first name',
    },
    lastName: {
      error: false,
      errorMessage: 'Please enter your last name',
    },
    firmName: {
      error: false,
      errorMessage: 'Please enter your firm name',
    },
    emailId: {
      error: false,
      errorMessage: 'Please enter your email address',
    },
    emailIdConfirm: {
      error: false,
      errorMessage: 'Email does not match',
    },
    phoneNumber: {
      error: false,
      errorMessage: 'Please enter a ten digit phone number',
    },
    zipCode: {
      error: false,
      errorMessage: 'Please enter your zip code',
    },
    disclosure: {
      error: false,
      errorMessage:
        'Please accept the Terms and Conditions to continue registration.',
    },
    password: {
      error: false,
      errorMessage: 'Please enter a password.',
    },
    passwordConfirm: {
      error: false,
      errorMessage: 'Password does not match.',
    },
  })

  useEffect(() => {
    setSelectedMode('register')
    loadTermsData()

    if (window.location.href.indexOf('validate-user') > 0) {
      validateUserInit()

      return
    }

    if (window.location.href.indexOf('terms-conditions') > 0) {
      setSelectedMode('registerInternal')

      return
    }

    const paramTokenNbr = urlSearchParams.get('user')

    switch (paramTokenNbr) {
      case 'changed-new':
        setSelectedModeType('changedNew')
        break
      case 'changed-else':
        setSelectedModeType('changedElse')
        break
    }
  }, [])

  useEffect(() => {
    switch (selectedMode) {
      case 'validate':
        validateUser()

        triggerDigitalDataSimple('Validate User', 'Validate User')

        break
      case 'additional':
        fetchFirms()

        triggerDigitalDataSimple(
          'Additional Information Required',
          'Additional Information Required'
        )

        break
      case 'password':
        triggerDigitalDataSimple('Create Password', 'Create Password')

        break
    }
  }, [selectedMode])

  useEffect(() => {
    switch (selectedModeType) {
      case 'changedNew':
      case 'changedElse':
        getAuthManagerInstance()
          .getProfileServiceBehaviorSubject()
          .subscribe((profile) => {
            if (profile) {
              const _formData = { ...formData }

              _formData.firstName = profile.firstNm
              _formData.lastName = profile.lastNm

              if (selectedModeType === 'changedNew') {
                _formData.emailId = profile.emailId
              }

              if (selectedModeType === 'changedElse') {
                _formData.emailIdAlt = profile.emailId
              }
              setFormData(_formData)
            }
          })
    }
  }, [selectedModeType])

  useEffect(() => {
    if (isProcessingRegister) {
      registerUser()
    }
  }, [isProcessingRegister])

  //fill in user info if those info exist in storageProfile
  useEffect(() => {
    if (storageProfile) {
      const _formData = { ...formData }
      const { emailId, firstName, lastName } = storageProfile
      if (emailId) _formData.emailId = storageProfile.emailId
      if (firstName) _formData.firstName = storageProfile.firstName
      if (lastName) _formData.lastName = storageProfile.lastName

      setFormData(_formData)
    }
  }, [])

  const fetchFirms = async () => {
    const _firms = await getFirms()
    if (_firms) {
      setFirms(_firms.value.firms)
    }
  }

  const validateUserInit = () => {
    const paramTokenNbr = urlSearchParams.get('tokenNbr')

    if (paramTokenNbr) {
      setToken(paramTokenNbr)

      setSelectedMode('validate')
    } else {
      setSelectedMode('register')
    }
  }

  const validateUser = async () => {
    if (IS_TESTING && isLocal()) {
      setLead(false)

      setSelectedMode('password')

      return
    }
    const headers = {}
    const corelationId = getCorelationIds()
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    const response = await fetchJsonRawReponse(
      `/adv.svc/lookupuser?tokenNbr=${token}`,
      headers
    )

    const data = await response.json()
    if (data.error && data.error.details) {
      const code = data.error.details.code
      if (code === 'CTN_LOOKUPUSER_0001' || code === 'CTN_LOOKUPUSER_0002') {
        triggerDigitalDataSimple(
          'Validate User - Expired',
          'Validate User - Expired'
        )

        setSelectedMode('confirmExpired')
      } else if (
        code === 'CTN_LOOKUPUSER_0003' ||
        code === 'CTN_LOOKUPUSER_0004'
      ) {
        triggerDigitalDataSimple(
          'Validate User - Already Registered',
          'Validate User - Already Registered'
        )

        window.location.href = '/login'
      } else {
        triggerDigitalDataSimple(
          'Validate User - Error',
          'Validate User - Error'
        )

        setSelectedMode('error')
      }

      return
    }

    let lead = data.value?.userTypeCd === 'LEAD'
    setLead(lead)
    setSelectedMode('additional')

    const _formData = { ...formData }

    if (data.value) {
      _formData.emailId = data.value.emailId
      _formData.firstName = data.value.userFirstNm
      _formData.lastName = data.value.userLastNm
    }

    _formData.firmName = (storageProfile && storageProfile.firmName) || ''

    setFormData(_formData)
  }

  const validateForm = () => {
    const _formValidation = { ...formValidation }

    switch (selectedMode) {
      case 'register':
        if (!formData.firstName) {
          _formValidation.firstName.error = true
        }

        if (!formData.lastName) {
          _formValidation.lastName.error = true
        }

        if (
          !formData.emailId ||
          !formData.emailId.includes('@') ||
          !formData.emailId.includes('.')
        ) {
          _formValidation.emailId.error = true
        }

        if (selectedModeType === 'changedElse') {
          if (
            !formData.emailIdConfirm ||
            !formData.emailIdConfirm.includes('@') ||
            !formData.emailIdConfirm.includes('.') ||
            !(formData.emailIdConfirm === formData.emailId)
          ) {
            _formValidation.emailIdConfirm.error = true
          } else {
            _formValidation.emailIdConfirm.error = false
          }
        }

        if (!selectedAgreementCheckbox) {
          _formValidation.disclosure.error = true
        }

        break
      case 'additional':
        if (!formData.firstNameLegal) {
          _formValidation.firstNameLegal.error = true
        }

        if (!formData.firstName) {
          _formValidation.firstName.error = true
        }

        if (!formData.lastName) {
          _formValidation.lastName.error = true
        }

        if (!formData.firmName) {
          _formValidation.firmName.error = true
        }

        if (!formData.zipCode || formData.zipCode.length < 5) {
          _formValidation.zipCode.error = true
        }

        if (
          !formData.phoneNumber ||
          formData.phoneNumber.replace(/\D/g, '').length !== 10
        ) {
          _formValidation.phoneNumber.error = true
        }

        break
      case 'password':
        if (!formData.password) {
          _formValidation.password.error = true
        }

        if (
          !formData.passwordConfirm ||
          formData.password !== formData.passwordConfirm
        ) {
          _formValidation.passwordConfirm.error = true
        }

        break
      case 'registerInternal':
        if (!selectedAgreementCheckbox) {
          _formValidation.disclosure.error = true
        }

        break
      default:
        break
    }

    return _formValidation
  }

  const onValidatePassword = (valid) => {
    setPasswordValid(valid)
  }

  const sendEmail = async () => {
    const url = '/adv.svc/submitUserEmailForReg'

    const emailPayLoad = {
      userId: formData.emailId,
      actionCd: 'new',
      userFirstNm: formData.firstName,
      userLastNm: formData.lastName,
    }

    switch (selectedModeType) {
      case 'changedNew':
        emailPayLoad['regType'] = 'ReReg_NewFirm'

        break
      case 'changedElse':
        emailPayLoad['regType'] = 'ReReg_AltFirm'
        emailPayLoad['altFirmId'] = formData.emailIdAlt

        break
    }
    const headers = {}
    const corelationId = setCorelationIds()
    headers.app_corelation_id = corelationId?.app_corelation_id
    headers.wam_corelation_id = corelationId?.wam_corelation_id
    const response = await postJsonDataBlankResponse(url, emailPayLoad, headers)

    if (response.ok) {
      setSelectedMode('confirm')
    } else {
      let responseData = await response.text()

      if (responseData) {
        responseData = JSON.parse(responseData)

        if (responseData.error && responseData.error.details) {
          const code = responseData.error.details.code
          if (code === 'CTN_USEREMAILREG_0002') {
            const _formValidation = { ...formValidation }

            _formValidation.emailId.error = true
            _formValidation.emailId.errorMessage =
              'Your email address domain must be firm-based. Please enter a new email address (ex. "name@firm.com").'

            setFormValidation(_formValidation)
          } else if (code === 'CTN_USEREMAILREG_0009') {
            // the definition of overkill error message
            // oh and btw, having an underscore in your domain is actually allowed according to the spec (https://tools.ietf.org/html/rfc2181#section-11)
            setSelectedModeError(
              'The email address you entered cannot be accepted because it includes an underscore symbol (_) after the @ sign. Please enter a different email address or call 800-248-2828 for assistance.'
            )
          } else {
            setSelectedModeError(responseData.error.details.message)

            setSelectedMode('confirmError')
          }
        } else {
          setSelectedMode('confirmError')
        }
      } else {
        setSelectedMode('confirmError')
      }
    }

    return response
  }

  const lookupFirmByName = (name) => {
    let foundFirm = ''

    firms.forEach((firm) => {
      if (firm.firmNm === name) {
        foundFirm = firm
      }
    })

    return foundFirm
  }

  const makeValidateAndCreateUserCalls = async (channel) => {
    setLoading(true)
    // Validate profile --------------------------------
    let validateProfileResponse
    if (validatedProfile) {
      validateProfileResponse = validatedProfile
    } else {
      const validateProfilePayload = {
        tokenNbr: token,
        userEmailAddr: formData.emailId,
        userFirstNm: formData.firstName,
        userLastNm: formData.lastName,
        legalFirstNm: formData.firstNameLegal,
        firmNm: formData.firmName,
        postalCd: formData.zipCode,
        phoneNbr: formData.phoneNumber.replace(/\D/g, ''),
        firmId: formData.firmId,
        firmStNm: formData.firmStNm,
        firmState: formData.firmState,
        firmCity: formData.firmCity,
        distrContactStatusCd: lead ? 'LEAD' : 'CONTACT',
      }

      const corelationId = getCorelationIds()
      const validateProfileHeaders = {
        apiToken: getItem('apiToken'),
        tmx_id: tmx_id,
        web_session_id: websession_id,
        profiled_url: window.location.href,
        app_corelation_id: corelationId?.app_corelation_id,
        wam_corelation_id: corelationId?.wam_corelation_id,
      }

      const validateProfileUrl = '/adv.svc/validateProfile'
      try {
        validateProfileResponse = await postJsonRawResponse(
          validateProfileUrl,
          validateProfilePayload,
          validateProfileHeaders
        )
        if (!validateProfileResponse.ok) {
          setSelectedMode('error')
        } else {
          setValidatedProfile(validateProfileResponse)
        }
      } catch (error) {
        setSelectedMode('error')
      }
    }

    // Create user ----------------------------------
    const createUserPayload = {
      tokenNbr: token,
      passwordTxt: formData.password,
      deviceSignature: window?.getDeviceSignature(),
      channel: channel,
    }
    const corelationId = getCorelationIds()
    const createUserHeaders = {
      Accept: 'application/json',
      'Content-type': 'application/json',
      apitoken: validatedProfile
        ? getItem('apiToken')
        : validateProfileResponse.headers.get('apitoken'),
      app_corelation_id: corelationId?.app_corelation_id,
      wam_corelation_id: corelationId?.wam_corelation_id,
      tmx_id: tmx_id,
      web_session_id: websession_id,
      profiled_url: window.location.href,
    }

    let responseCreateUser = getCreateUser()

    if (!isLocal()) {
      const createUserUrl = '/adv.svc/createuser'

      try {
        responseCreateUser = await postJsonRawResponse(
          createUserUrl,
          createUserPayload,
          createUserHeaders
        )
        if (responseCreateUser.ok) {
          const apitoken = responseCreateUser.headers.get('apitoken')
          setItem('apiToken', apitoken)
          setSelectedMode('otp')
        } else {
          setSelectedMode('error')
        }
      } catch {
        setSelectedMode('error')
      } finally {
        setLoading(false)
      }
    }
  }

  const onChangeInputPassword = (event) => {
    setShowPasswordValidator(!!event.target.value)

    onChangeInput(event)
  }

  const onChangeInput = (event) => {
    let textInputValue = event.target.value
    const textFieldName = event.target.dataset.fieldName

    const _formData = { ...formData }
    if (textFieldName === 'phoneNumber') {
      const digits = event.target.value.replace(/\D/g, '').slice(0, 10)
      textInputValue = digits
      if (digits.length > 0) {
        textInputValue = digits.slice(0, 3)
        if (digits.length >= 4) {
          textInputValue += '.' + digits.slice(3, 6)
        }
        if (digits.length >= 7) {
          textInputValue += '.' + digits.slice(6, 10)
        }
      }
      setMaskedPhoneNbr(textInputValue)
    }
    if (textFieldName === 'password' || textFieldName === 'passwordConfirm') {
      textInputValue = textInputValue?.replace(/[\\"]/g, '')
    }
    _formData[textFieldName] = textInputValue

    const _formValidation = { ...formValidation }
    _formValidation[textFieldName].error = false

    setFormData(_formData)
    setFormValidation(_formValidation)
  }

  const onChangeInputFirm = (event) => {
    const firmName = event.target.value

    const firm = lookupFirmByName(event.target.value)

    const _formData = { ...formData }
    _formData.firmName = firmName

    const _formValidation = { ...formValidation }
    _formValidation.firmName.error = false

    if (firm) {
      _formData.firmId = firm.firmId
      _formData.firmStNm = firm.firmStNm
      _formData.firmState = firm.firmState
      _formData.firmCity = firm.firmCity
    } else {
      _formData.firmId = ''
      _formData.firmStNm = ''
      _formData.firmState = ''
      _formData.firmCity = ''
    }

    setFormData(_formData)
  }

  const onClickToggleDisclosure = () => {
    setSelectedToggleDisclosure(!selectedToggleDisclosure)
  }

  const onChangeAgreementCheckbox = (event) => {
    const _formValidation = { ...formValidation }

    _formValidation.disclosure.error = false

    setFormValidation(_formValidation)

    setSelectedAgreementCheckbox(event.target.checked)
  }

  const onClickContinueBrowsing = (event) => {
    event.preventDefault()

    window.location = getRelativeBasePath()
  }

  const onClickRegisterInternal = async (event) => {
    event.preventDefault()

    const _formValidation = validateForm()

    const isError = Object.entries(_formValidation).find(
      ([, value]) => value.error
    )

    if (!isError) {
      const url = '/adv.svc/secure/termsAndConditions'

      await postJsonDataBlankResponse(url, {})

      // clear this from the cache so on the landing page, the profile service is updated with the ToC flag toggled correctly
      clearAllCache()

      goToSecurePageRedirect()
    } else {
      setFormValidation(_formValidation)
    }
  }

  const onClickRegister = (event) => {
    event.preventDefault()

    setIsProcessingRegister(true)
  }

  const registerUser = async () => {
    const _formValidation = validateForm()

    const isError = Object.entries(_formValidation).find(
      ([, value]) => value.error
    )

    if (!isError) {
      setSelectedModeError('')
      setSelectedModeType('')

      if (checkIfEmailIsInternal(formData.emailId)) {
        window.location.href = getInternalRedirectLoginUrl()

        return
      }

      if (IS_TESTING && isLocal()) {
        await sleep(5000)
      } else {
        await sendEmail()
      }

      window.scrollTo(0, 0)

      setSelectedToggleDisclosure(false)
    } else {
      setFormValidation(_formValidation)
    }

    setIsProcessingRegister(false)
  }

  const onClickAdditional = (event) => {
    event.preventDefault()

    const _formValidation = validateForm()

    const isError = Object.entries(_formValidation).find(
      ([, value]) => value.error
    )

    if (!isError) {
      setSelectedMode('password')

      window.scrollTo(0, 0)
    } else {
      setFormValidation(_formValidation)
    }
  }

  const onClickPassword = (event) => {
    event.preventDefault()

    const _formValidation = validateForm()

    const isError = Object.entries(_formValidation).find(
      ([, value]) => value.error
    )

    if (!isError) {
      setSelectedMode('challenge-choice')

      window.scrollTo(0, 0)
    } else {
      setFormValidation(_formValidation)
    }
  }

  const onClickResend = (event) => {
    event.preventDefault()

    const response = sendEmail()

    if (!response.ok) {
      setSelectedMode('confirmError')
    }

    setSelectedMode('confirmResend')
  }

  const onClickBack = (event) => {
    event.preventDefault()

    setSelectedMode('register')
  }

  const onClickCancel = (event) => {
    event.preventDefault()

    window.location = getRelativeBasePath() + '/register'
  }

  const renderButtons = () => {
    return (
      <div className="u-paddingTop4gu u-paddingBottom12gu">
        <button
          className="Button Button--secondary u-marginRight4gu u-paddingHoriz5gu u-sm-sizeFull u-textNoTransform"
          data-analytics={
            selectedMode === 'register'
              ? 'register-enter-info-cancel'
              : selectedMode === 'additional'
                ? 'register-additional-info-cancel'
                : 'register-create-password-cancel'
          }
          onClick={
            selectedMode === 'registerInternal' || selectedMode === 'register'
              ? onClickContinueBrowsing
              : onClickCancel
          }
        >
          Cancel
        </button>
        <button
          className="Button Button--primary u-paddingHoriz5gu u-sm-marginTop2gu u-sm-sizeFull u-textNoTransform"
          data-analytics={
            selectedMode === 'register'
              ? 'register-enter-info-continue'
              : selectedMode === 'additional'
                ? 'register-additional-info-continue'
                : 'register-create-password-continue'
          }
          onClick={
            selectedMode === 'registerInternal'
              ? onClickRegisterInternal
              : selectedMode === 'register'
                ? onClickRegister
                : selectedMode === 'additional'
                  ? onClickAdditional
                  : onClickPassword
          }
        >
          Next
          {isProcessingRegister && <LoadingIndicator />}
        </button>
      </div>
    )
  }

  const loadTermsData = async () => {
    const url = `${getLocalPath()}/halapi/documents?_scope=/content/documents/cti-advisor/login-and-registration/terms-conditions-content`
    try {
      const response = await safeFetch(url)
      const data = ((await response.json()) || {})?._embedded?.documents[0]
      setDisclosureData({
        heading: data?.title,
        content: data?.html?.content,
      })
    } catch (err) {
      console.log(err)
    }
  }

  const handleChallengeChoiceNext = (choice) => {
    makeValidateAndCreateUserCalls(choice)
  }

  const handleRegistrationDisplayChange = async (display, data) => {
    if (display === 'no-code-received') {
      setSelectedMode('challenge-choice')
    } else if (display === 'subscribed') {
      window._satellite?.track('registration_success_ctn')
      setLogin(data?.value?.userInfo?.userId, null)
      try {
        const profileData = await getSecureProfile()
        setEmailSubscriptionCenterProfileCookie(profileData.value)

        const subData = await postCheckSubscription()
        if (subData.value) {
          if (subData.value.contactID) {
            setContactKey(subData.value.contactID)
          }
        }
      } catch (error) {
        console.error('Subscription center sign in error', error)
      }
      goToRegistrationPageRedirect()
    }
  }

  const tab1 =
    selectedMode !== 'password' &&
    selectedMode !== 'additional' &&
    selectedMode !== 'challenge-choice' &&
    selectedMode !== 'otp'

  const heading =
    selectedMode === 'register'
      ? 'Enter Your Information'
      : selectedMode === 'confirm'
        ? 'Confirm Your Email'
        : selectedMode === 'confirmResend'
          ? 'New Email Sent'
          : selectedMode === 'confirmError'
            ? 'An Error Occurred'
            : selectedMode === 'confirmExpired'
              ? 'The confirmation link has expired'
              : selectedMode === 'password'
                ? 'Create New Password'
                : selectedMode === 'additional'
                  ? 'Additional Information Required'
                  : selectedMode === 'validate'
                    ? 'We are verifying your email address...'
                    : ''
  return (
    <div className="u-posRelative register-scope investment-products">
      {/* TABS */}
      {selectedMode !== 'registerInternal' && (
        <div className="u-sizeConstrained u-marginTop8gu">
          <div className="u-flex u-flexJustifyStart">
            <h4
              className={`u-textBold u-paddingHoriz2gu u-paddingVert3gu u-borderWidthMedium u-borderColorTertiary ${
                tab1 && 'u-borderBottom'
              }`}
            >
              1: Enter/Confirm information
            </h4>
            <h4
              className={`u-textBold u-paddingHoriz2gu u-paddingVert3gu u-marginLeft4gu u-borderWidthMedium u-borderColorSecondary ${
                !tab1 && 'u-borderBottom'
              }`}
            >
              2: Create password
            </h4>
          </div>
        </div>
      )}
      <Loader showBackground={false} isTransparent={true} isLoading={loading} />
      <div className="u-bgColorLightest">
        <div className="u-sizeConstrained">
          <div className="u-paddingBottom8gu ">
            {heading && (
              <h2 className="u-paddingBottom2gu u-paddingTop12gu u-borderBottom u-inlineBlock u-borderBottomColorBrandLighter">
                {heading}
              </h2>
            )}
            {(selectedModeType || selectedModeError) && (
              <div className="u-flex u-flexAlignItemsCenter u-marginTop5gu u-padding5gu u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft u-borderRight">
                <i>
                  <span
                    aria-hidden="true"
                    className="Icon u-textSizeMsrp1 u-textColorAlert"
                  >
                    &#x2139;
                  </span>
                  <span className="u-hiddenVisually">Warning</span>
                </i>
                <div
                  className="u-marginLeft1gu"
                  data-analytics={selectedModeError ? 'register-error' : null}
                >
                  {selectedModeType && (
                    <>
                      <strong>
                        Because your email address is also your User ID
                      </strong>
                      , please reregister and confirm your new email for
                      continued access. Thank you.
                    </>
                  )}
                  {selectedModeError && <>{selectedModeError}</>}
                </div>
              </div>
            )}
          </div>
          {selectedMode === 'register' ||
          selectedMode === 'registerInternal' ? (
            <>
              {selectedMode === 'register' && (
                <div
                  className="form-registration u-size1of2 u-sm-sizeFull"
                  data-analytics-registration-step="Enter Your Information"
                >
                  <Step1Investor
                    formValidation={formValidation}
                    formData={formData}
                    handleInputChange={onChangeInput}
                    disabledEmail={selectedModeType === 'changedNew'}
                  />
                  {selectedModeType === 'changedElse' && (
                    <div className="u-paddingHoriz6gu">
                      <InputGroup
                        handleInputChange={onChangeInput}
                        formValidation={formValidation}
                        formData={formData}
                        fieldName="emailIdConfirm"
                        fieldId="emailIdConfirm"
                        placeholder="Confirm Email Address"
                        label="Confirm Email Address"
                      />
                    </div>
                  )}
                </div>
              )}
              <div
                className={
                  'u-posRelative  u-paddingTop2gu view-more-container' +
                  (selectedToggleDisclosure ? '' : ' min')
                }
              >
                <h2 className="u-marginBottom2gu">{disclosureData?.heading}</h2>
                <div
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(disclosureData?.content),
                  }}
                />
              </div>
              <div className="u-flex u-flexJustifyEnd u-paddingTop8gu u-paddingBottom4gu">
                <button
                  className="Button Button--primary u-textNoTransform"
                  onClick={onClickToggleDisclosure}
                >
                  {selectedToggleDisclosure ? 'View less' : 'View more'}
                </button>
              </div>
              <div>
                <div className="Checkbox">
                  <input
                    type="checkbox"
                    id={'agreementCheckbox'}
                    className="Checkbox-button u-hidden"
                    checked={selectedAgreementCheckbox}
                    value={'Yes'}
                    onChange={onChangeAgreementCheckbox}
                  />
                  <label
                    htmlFor={'agreementCheckbox'}
                    className="Checkbox-label u-margin0"
                  >
                    <div className="u-marginRight2gu u-textNoWrap">I agree</div>
                  </label>
                </div>
                <FormFieldError
                  formValidation={formValidation}
                  fieldName="disclosure"
                />
              </div>
              {selectedMode === 'register' && (
                <div>
                  By registering for this site, I certify that I am a financial
                  professional.
                </div>
              )}
            </>
          ) : selectedMode === 'confirm' ? (
            <div className="u-paddingHoriz6gu">
              <p>
                We&apos;ve sent a confirmation email to:{' '}
                <strong>{formData.emailId}</strong>. Please click on the link in
                the email to continue registration.
              </p>
              <p>
                <strong>Important:</strong> The link provided in the email
                expires after 24 hours.
              </p>
              <p>
                <strong>Didn&apos;t receive an email?</strong> If your email
                address is incorrect,{' '}
                <button className="Link" onClick={onClickBack}>
                  re-enter it now
                </button>{' '}
                or{' '}
                <button className="Link" onClick={onClickResend}>
                  request a new email
                </button>
                .
              </p>
            </div>
          ) : selectedMode === 'confirmResend' ? (
            <div className="u-paddingHoriz6gu">
              <p>
                We&apos;ve sent a new confirmation email to:{' '}
                <strong>{formData.emailId}</strong>. Please click on the link in
                the email to continue registration.
              </p>
            </div>
          ) : selectedMode === 'confirmError' ? (
            <div className="u-paddingHoriz6gu">
              <p>
                We&apos;re sorry but an error as occurred sending the
                confirmation email.{' '}
                <button
                  className="Link"
                  onClick={onClickBack}
                  data-analytics="register-try-again"
                >
                  Try again
                </button>
                .
              </p>
            </div>
          ) : selectedMode === 'confirmExpired' ? (
            <div className="u-paddingHoriz6gu">
              <p>
                Please{' '}
                <button className="Link" onClick={onClickCancel}>
                  re-enter your information
                </button>{' '}
                to receive a new email.
              </p>
            </div>
          ) : selectedMode === 'password' ? (
            <div className="u-paddingHoriz6gu">
              <div
                className="form-password u-size1of2 u-sm-sizeFull"
                data-analytics-registration-step="Create Password"
              >
                <InputGroup
                  formValidation={formValidation}
                  formData={formData}
                  type="password"
                  fieldName="password"
                  fieldId="password"
                  label="New password"
                  handleInputChange={onChangeInputPassword}
                  defaultValue={formData?.password}
                  maskedValue={formData?.password}
                />
                {showPasswordValidator && (
                  <div
                    className={
                      'u-marginBottom5gu u-padding2gu u-bgColorWhite u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft u-borderRight' +
                      (passwordValid ? ' u-hidden' : '')
                    }
                    style={{ transform: 'translateY(-36px)' }}
                  >
                    <PasswordValidator
                      username={formData.emailId}
                      passwordInput={formData.password}
                      onValidate={onValidatePassword}
                    />
                  </div>
                )}
                <InputGroup
                  formValidation={formValidation}
                  formData={formData}
                  type="password"
                  fieldName="passwordConfirm"
                  fieldId="passwordConfirm"
                  label="Confirm password"
                  handleInputChange={onChangeInput}
                  defaultValue={formData?.passwordConfirm}
                  maskedValue={formData?.passwordConfirm}
                />
              </div>
            </div>
          ) : selectedMode === 'additional' ? (
            <>
              <div className="u-marginBottom5gu">
                <p>
                  Please provide the information below to continue with
                  registration.
                </p>
              </div>
              <div
                className="form-additional u-size1of2 u-sm-sizeFull"
                data-analytics-registration-step="Additional Information Required"
              >
                <div className="u-flex u-flexAlignItemsCenter u-flexJustifyEnd u-textItalic">
                  All fields required
                </div>
                <AdditionalInformation
                  handleInputChange={onChangeInput}
                  handleFirmInputChange={onChangeInputFirm}
                  maskedPhoneNbr={maskedPhoneNbr}
                  formValidation={formValidation}
                  formData={formData}
                  firms={firms}
                />
              </div>
            </>
          ) : selectedMode === 'challenge-choice' ? (
            <ChallengeChoice
              handleDisplayChange={handleChallengeChoiceNext}
              phoneNumber={formData.phoneNumber}
              mode="registration"
            />
          ) : selectedMode === 'otp' ? (
            <OneTimePasscode
              handleDisplayChange={handleRegistrationDisplayChange}
              otpData={{
                registrationData: {
                  apiToken: getItem('apiToken'),
                  tokenNbr: token,
                  password: formData.password,
                },
              }}
              phoneNumber={formData.phoneNumber}
              websession_id={websession_id}
              setLoading={setLoading}
            />
          ) : selectedMode === 'error' ? (
            <div className="u-paddingHoriz6gu">
              <p>
                We&apos;re sorry but an error as occurred. Please try again
                later.
              </p>
            </div>
          ) : null}
          {selectedMode === 'registerInternal' ||
          selectedMode === 'register' ||
          selectedMode === 'additional' ||
          selectedMode === 'password' ? (
            <div className="u-flex u-flexAlignItemsCenter u-flexJustifyEnd">
              {renderButtons()}
            </div>
          ) : (
            <div>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
